import { apiClient } from "./client";

const FilterPlanInfo = (data) => {
  return apiClient.post('/PlanInfo/FilterPlanInfo',
    {
      "cityConsistency": data.cityConsistency,
      "hotelId": data.hotelId,
      "planCode": data.planCode,
      "hotelStractureId": data.hotelStractureId,
      "paginationParam": {
        "orderBy": data.orderBy,
        "orderDescending": data.orderDescending,
        "pageNumber": data.pageNumber,
        "pageSize": data.pageSize
      }

    }
  );
}
const UpdateDescriptionPlan = (data) => {
  return apiClient.put('/PlanInfo/UpdateDescriptionPlan', {
    "id": data.id,
    "firstDescription": data.firstDescription,
    "secondDescription": data.secondDescription,
    "thirdDescription": data.thirdDescription
  }
  )
}
const planInfoApi = { FilterPlanInfo, UpdateDescriptionPlan }
export default planInfoApi;